import React from "react";
import SubscribeBox from '../components/SubscribeBox'
import styles from './digest.module.scss'
import './digest.scss'
import Helmet from 'react-helmet'

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { context: {html, title, date, index, image}} = data.sitePage;

  return (
    <div className={styles.digest}>
      <Helmet>
        <title>{`ML Review – Digest #${index}`}</title>
        <meta name="description" content={title}></meta>
        <meta property="og:title" content={`ML Review – Digest #${index}`} />
        <meta property="og:description" content={title}></meta>
        {image && <meta property="og:image" content={'https://mlreview.com' + image.publicURL} />}
      </Helmet>
      <div>
        <h2>{title}</h2>
        <span className={styles.meta}>
          Digest #{index} • <time>{date}</time>
        </span>
        <hr />
        <div
          className="digest-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
      <hr />
      <p>Don’t miss out the next digest, make sure you are subscribed to our newsletter.</p>
      <SubscribeBox />
    </div>
  );
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    sitePage(path: {eq: $path}) {
      path
      context {
        title
        html
        date(formatString: "MMMM YYYY")
        index
        image {
          publicURL
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/digest.js